import { render, staticRenderFns } from "./CategroyModal.vue?vue&type=template&id=07a8a3e5"
import script from "./CategroyModal.vue?vue&type=script&lang=js"
export * from "./CategroyModal.vue?vue&type=script&lang=js"
import style0 from "./CategroyModal.vue?vue&type=style&index=0&id=07a8a3e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports